// import ApexChartBE from "./BEApexCharts"

// const StatisticContentBE = () => {
//  return (
//     <>
//       <div className="content-body">
//   <div className="container-fluid">
//     <div className="row">
//       <div className="col-xl-3 col-sm-6">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div className="icon-box icon-box-lg bg-success-light rounded-circle">
//                 <svg
//                 width="46"
//                 height="46"
//                 viewBox="0 0 46 46"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//                 >
//                 {/* Document */}
//                 <rect
//                     x="10"
//                     y="8"
//                     width="26"
//                     height="30"
//                     rx="2"
//                     stroke="#3AC977"
//                     strokeWidth="2"
//                 />
//                 {/* Lignes du document */}
//                 <line x1="14" y1="16" x2="32" y2="16" stroke="#3AC977" strokeWidth="2" />
//                 <line x1="14" y1="22" x2="32" y2="22" stroke="#3AC977" strokeWidth="2" />
//                 <line x1="14" y1="28" x2="26" y2="28" stroke="#3AC977" strokeWidth="2" />
//                 {/* Flèche de soumission */}
//                 <path
//                     d="M33 34 L38 29 M38 29 L33 24"
//                     stroke="#3AC977"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                 />
//                 <path
//                     d="M38 29H26"
//                     stroke="#3AC977"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                 />
//                 </svg>
//               </div>
//               <div className="total-projects ms-3">
//                 <h3 className="text-success count">32</h3>
//                 <span>Total Clients</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-sm-6">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div className="icon-box icon-box-lg bg-primary-light rounded-circle">
//                 <svg
//                   width={46}
//                   height={64}
//                   viewBox="0 0 46 46"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     fillRule="evenodd"
//                     clipRule="evenodd"
//                     d="M32.8961 26.5849C34.1612 26.5849 35.223 27.629 35.0296 28.8783C33.8947 36.2283 27.6026 41.6855 20.0138 41.6855C11.6178 41.6855 4.8125 34.8803 4.8125 26.4862C4.8125 19.5704 10.0664 13.1283 15.9816 11.6717C17.2526 11.3579 18.5553 12.252 18.5553 13.5605C18.5553 22.4263 18.8533 24.7197 20.5368 25.9671C22.2204 27.2145 24.2 26.5849 32.8961 26.5849Z"
//                     stroke="var(--primary)"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     fillRule="evenodd"
//                     clipRule="evenodd"
//                     d="M41.1733 19.2019C41.2739 13.5059 34.2772 4.32428 25.7509 4.48217C25.0877 4.49402 24.5568 5.04665 24.5272 5.70783C24.3121 10.3914 24.6022 16.4605 24.764 19.2118C24.8134 20.0684 25.4864 20.7414 26.341 20.7907C29.1693 20.9526 35.4594 21.1736 40.0759 20.4749C40.7035 20.3802 41.1634 19.8355 41.1733 19.2019Z"
//                     stroke="var(--primary)"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </div>
//               <div className="total-projects ms-3">
//                 <h3 className="text-primary count">132</h3>
//                 <span>Projets Soumis</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-sm-6">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div className="icon-box icon-box-lg bg-purple-light rounded-circle">
//                 <svg
//                   width={46}
//                   height={64}
//                   viewBox="0 0 46 46"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     fillRule="evenodd"
//                     clipRule="evenodd"
//                     d="M22.9717 41.0539C22.9717 41.0539 37.3567 36.6983 37.3567 24.6908C37.3567 12.6814 37.878 11.7439 36.723 10.5889C35.5699 9.43391 24.858 5.69891 22.9717 5.69891C21.0855 5.69891 10.3736 9.43391 9.21863 10.5889C8.0655 11.7439 8.58675 12.6814 8.58675 24.6908C8.58675 36.6983 22.9717 41.0539 22.9717 41.0539Z"
//                     stroke="#BB6BD9"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     d="M26.4945 26.4642L19.4482 19.4179"
//                     stroke="#BB6BD9"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     d="M19.4487 26.4642L26.495 19.4179"
//                     stroke="#BB6BD9"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </div>
//               <div className="total-projects ms-3">
//                 <h3 className="text-purple count">528</h3>
//                 <span>En Attente de Traitement</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-sm-6">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div className="icon-box icon-box-lg bg-purple-light rounded-circle">
//                 <svg
//                   width={46}
//                   height={64}
//                   viewBox="0 0 46 46"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     fillRule="evenodd"
//                     clipRule="evenodd"
//                     d="M22.9717 41.0539C22.9717 41.0539 37.3567 36.6983 37.3567 24.6908C37.3567 12.6814 37.878 11.7439 36.723 10.5889C35.5699 9.43391 24.858 5.69891 22.9717 5.69891C21.0855 5.69891 10.3736 9.43391 9.21863 10.5889C8.0655 11.7439 8.58675 12.6814 8.58675 24.6908C8.58675 36.6983 22.9717 41.0539 22.9717 41.0539Z"
//                     stroke="#BB6BD9"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     d="M26.4945 26.4642L19.4482 19.4179"
//                     stroke="#BB6BD9"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     d="M19.4487 26.4642L26.495 19.4179"
//                     stroke="#BB6BD9"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </div>
//               <div className="total-projects ms-3">
//                 <h3 className="text-purple count">528</h3>
//                 <span>Projets Etudiés</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-xl-3 col-sm-6">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div className="icon-box icon-box-lg bg-danger-light rounded-circle">
//                 <svg
//                   width={46}
//                   height={64}
//                   viewBox="0 0 46 46"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"  
//                 >
//                   <path
//                     d="M34.0396 20.974C36.6552 20.6065 38.6689 18.364 38.6746 15.6471C38.6746 12.9696 36.7227 10.7496 34.1633 10.3296"
//                     stroke="#FF5E5E"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     d="M37.4912 27.262C40.0243 27.6407 41.7925 28.5276 41.7925 30.3557C41.7925 31.6139 40.96 32.4314 39.6137 32.9451"
//                     stroke="#FF5E5E"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     fillRule="evenodd"
//                     clipRule="evenodd"
//                     d="M22.7879 28.0373C16.7616 28.0373 11.6147 28.9504 11.6147 32.5973C11.6147 36.2423 16.7297 37.1817 22.7879 37.1817C28.8141 37.1817 33.9591 36.2779 33.9591 32.6292C33.9591 28.9804 28.846 28.0373 22.7879 28.0373Z"
//                     stroke="#FF5E5E"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     fillRule="evenodd"
//                     clipRule="evenodd"
//                     d="M22.7876 22.8325C26.742 22.8325 29.9483 19.6281 29.9483 15.6719C29.9483 11.7175 26.742 8.51123 22.7876 8.51123C18.8333 8.51123 15.627 11.7175 15.627 15.6719C15.612 19.6131 18.7939 22.8194 22.7351 22.8325H22.7876Z"
//                     stroke="#FF5E5E"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     d="M11.5344 20.974C8.91691 20.6065 6.90504 18.364 6.89941 15.6471C6.89941 12.9696 8.85129 10.7496 11.4107 10.3296"
//                     stroke="#FF5E5E"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     d="M8.0825 27.262C5.54937 27.6407 3.78125 28.5276 3.78125 30.3557C3.78125 31.6139 4.61375 32.4314 5.96 32.9451"
//                     stroke="#FF5E5E"
//                     strokeWidth={2}
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </div>
//               <div className="total-projects ms-3">
//                 <h3 className="text-danger count">54</h3>
//                 <span>Projets Abandonés</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div>
//         <ApexChartBE />
//       </div>
//     </div>
//   </div>
// </div>


//     </>
//   )
// }

// export default StatisticContentBE

import ApexChartBE from "./BEApexCharts";

const StatisticContentBE = () => {
  return (
    <>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            {/* Total Clients */}
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="icon-box icon-box-lg bg-success-light rounded-circle">
                      {/* Utilisateur */}
                      <svg width="46" height="64" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="7" r="4" stroke="#3AC977" strokeWidth="2" />
                        <path
                          d="M4 20c0-4 4-6 8-6s8 2 8 6"
                          stroke="#3AC977"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div className="total-projects ms-3">
                      <h3 className="text-success count">32</h3>
                      <span>Total Clients</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Projets Soumis */}
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="icon-box icon-box-lg bg-primary-light rounded-circle">
                      {/* Icône Soumission */}
                      <svg width="46" height="64" viewBox="0 0 24 24" fill="none">
                        <rect x="4" y="3" width="16" height="20" rx="2" stroke="#3A7AFE" strokeWidth="2" />
                        <path
                          d="M8 7h8M8 11h5M12 17l3-3-3-3"
                          stroke="#3A7AFE"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="total-projects ms-3">
                      <h3 className="text-primary count">132</h3>
                      <span>Projets Soumis</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* En Attente de Traitement */}
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="icon-box icon-box-lg bg-warning-light rounded-circle">
                      {/* Icône horloge */}
                      <svg width="46" height="64" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="#FFA500" strokeWidth="2" />
                        <path d="M12 6v6l4 2" stroke="#FFA500" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    </div>
                    <div className="total-projects ms-3">
                      <h3 className="text-warning count">528</h3>
                      <span>Projets En Cours</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Projets Étudiés */}
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="icon-box icon-box-lg bg-info-light rounded-circle">
                      {/* Loupe / Etude */}
                      <svg width="46" height="64" viewBox="0 0 24 24" fill="none">
                        <circle cx="11" cy="11" r="7" stroke="#00B8D9" strokeWidth="2" />
                        <line x1="16" y1="16" x2="21" y2="21" stroke="#00B8D9" strokeWidth="2" />
                      </svg>
                    </div>
                    <div className="total-projects ms-3">
                      <h3 className="text-info count">528</h3>
                      <span>Projets Étudiés</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Projets Abandonnés */}
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="icon-box icon-box-lg bg-danger-light rounded-circle">
                      {/* Icône croix / abandon */}
                      <svg width="46" height="64" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="#FF5E5E" strokeWidth="2" />
                        <line x1="9" y1="9" x2="15" y2="15" stroke="#FF5E5E" strokeWidth="2" />
                        <line x1="15" y1="9" x2="9" y2="15" stroke="#FF5E5E" strokeWidth="2" />
                      </svg>
                    </div>
                    <div className="total-projects ms-3">
                      <h3 className="text-danger count">54</h3>
                      <span>Projets Abandonnés</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Graphique */}
            <div>
              <ApexChartBE />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatisticContentBE;